import { ComponentProps, ComponentRef, forwardRef } from "react";
import { twMerge } from "tailwind-merge";

export type CardProps = ComponentProps<"section"> & {
  upperBorderColor?: string;
  roundedClass?: string;
};

const DEFAULT_ROUNDED_CLASS = "rounded-none sm:rounded-xl";

export const Card = forwardRef<ComponentRef<"section">, CardProps>(
  ({ children, className, upperBorderColor, roundedClass, ...props }, ref) => {
    return (
      <section
        {...props}
        className={twMerge(
          "relative h-full w-full bg-white px-4 py-6 shadow",
          roundedClass ?? DEFAULT_ROUNDED_CLASS,
          "sm:px-6",
          className
        )}
        ref={ref}
      >
        {upperBorderColor && (
          <div
            style={{
              borderTop: `10px solid ${upperBorderColor}`,
            }}
            className={twMerge(
              "absolute left-0 top-0 w-full rounded-t-[inherit] after:absolute after:-top-[5px] after:left-0 after:h-[5px] after:w-full after:bg-white"
            )}
          />
        )}
        {children}
      </section>
    );
  }
);
Card.displayName = "Card";
